import { GA_TRACKING_ID_PROD, GA_TRACKING_ID_TEST } from "config/constants";
import { isProd, isTest } from "config/env";

export const getPageName = (pathname: string): string => {
  if (pathname.includes("/daily-status")) return "Daily Status";
  if (pathname.includes("/customer-service/ai-assistant")) return "BonverBot";
  if (pathname.includes("/customer-service")) return "Customer Service";
  if (pathname.includes("/forecast")) return "Forecast";
  if (pathname.includes("/quality/inbound")) return "Quality - Inbound";
  if (pathname.includes("/quality/return")) return "Quality - Return";
  if (pathname.includes("/quality/delivery-accuracy"))
    return "Quality - Delivery Accuracy";
  if (pathname.includes("/quality")) return "Quality";
  if (pathname.includes("/cost-control/cost")) return "Cost Control - Cost";
  if (pathname.includes("/cost-control/order")) return "Cost Control - Order";
  if (pathname.includes("/cost-control/inventory"))
    return "Cost Control - Inventory";
  if (pathname.includes("/cost-control/freights"))
    return "Cost Control - Freights";
  if (pathname.includes("/cost-control")) return "Cost Control";
  if (pathname.includes("/invoices")) return "Invoices";
  if (pathname.includes("/admin")) return "Admin";
  if (pathname.includes("/users")) return "Users";
  if (pathname.includes("/health-check")) return "Health Check";
  return "General";
};

export const getCustomerIdFromUrl = (url: string): string | undefined => {
  const path = url.split("?")[0]; // strip query string
  const segments = path.split("/").filter(Boolean);
  return segments.length > 0 ? segments[0] : undefined;
};

export interface PageviewParams {
  url: string;
  customerId?: string;
  customerName?: string;
  pageName?: string;
  userName?: string;
  userEmailDomain?: string;
  isInternalUser?: boolean;
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = ({
  url,
  customerId,
  customerName,
  pageName,
  userName,
  userEmailDomain,
  isInternalUser,
}: PageviewParams) => {
  const userProperties: Record<string, string> = {};
  if (customerId) userProperties.customer_code = customerId;
  if (customerName) userProperties.customer_name = customerName;
  if (userName) userProperties.user_name = userName;
  if (userEmailDomain) userProperties.user_email_domain = userEmailDomain;
  if (isInternalUser !== undefined)
    userProperties.is_internal_user = String(isInternalUser);

  if (Object.keys(userProperties).length > 0) {
    if (isTest) {
      // @ts-ignore
      window.gtag("set", "user_properties", userProperties);
    }
    if (isProd) {
      // @ts-ignore
      window.gtag("set", "user_properties", userProperties);
    }
  }

  const eventParams: Record<string, string> = {
    page_path: url,
  };
  if (customerId) eventParams.customer_code = customerId;
  if (customerName) eventParams.customer_name = customerName;
  if (pageName) eventParams.page_name = pageName;
  if (userName) eventParams.user_name = userName;
  if (userEmailDomain) eventParams.user_email_domain = userEmailDomain;
  if (isInternalUser !== undefined)
    eventParams.is_internal_user = String(isInternalUser);

  if (isTest) {
    // @ts-ignore
    window.gtag("config", GA_TRACKING_ID_TEST, {
      page_path: url,
      send_page_view: false,
    });
    // @ts-ignore
    window.gtag("event", "page_view", eventParams);
  }
  if (isProd) {
    // @ts-ignore
    window.gtag("config", GA_TRACKING_ID_PROD, {
      page_path: url,
      send_page_view: false,
    });
    // @ts-ignore
    window.gtag("event", "page_view", eventParams);
  }
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export interface EventParams {
  action: string;
  category?: string;
  label?: string;
  value?: number;
  customer_code?: string;
  [key: string]: any;
}

export const event = ({
  action,
  category,
  label,
  value,
  customer_code,
  ...rest
}: EventParams) => {
  const currentPath = window.location.pathname;
  const eventParams = {
    event_category: category || getPageName(currentPath),
    event_label: label,
    value: value,
    customer_code: customer_code || getCustomerIdFromUrl(currentPath),
    ...rest,
  };

  if (isTest) {
    // @ts-ignore
    window.gtag("event", action, eventParams);
  }
  if (isProd) {
    // @ts-ignore
    window.gtag("event", action, eventParams);
  }
};
